module.exports = require("object-assign");


//////////////////
// WEBPACK FOOTER
// external "object-assign"
// module id = 45
// module chunks = 0